module.exports = __webpack_public_path__ + "static/media/169-liberia.34c9162b.svg";